import React from "react";
import { connect } from "react-redux";
import { Modal, Form } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicButton from "../../components/frame/DynamicButton";
import ReduxAbstract from "../../components/abstract/Redux.abstract";
import {
	changeInsuranceManagement,
	selectInsuranceManagement,
	updateInsuranceManagement,
} from "../../actions/salary-allowance-actions";
import insuranceManagementService 
from "../../services/SalaryAllowance/insurance-management-service";


class InsuranceManagement extends ReduxAbstract {

	initReload = true
	deleteRowSelection = true
	moduleName = "salaryAllowance"
	childModuleName = "insuranceManagement"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		importModalStatus: false
	}

	actions = {
		changeAction: this.props.changeInsuranceManagement,
		selectAction: this.props.selectInsuranceManagement,
		updateAction: this.props.updateInsuranceManagement,

		deleteAction: insuranceManagementService.deleteInsuranceManagement,
		createAction: insuranceManagementService.createInsuranceManagement,
	}

	tableColumn = [{
			title: '地区',
			dataIndex: 'area',
			key: 'area',
			className: 'table-global-head-tiny'
		},{
			title: '个税基数',
			dataIndex: 'personal_tax_base',
			key: 'personal_tax_base',
			className: 'table-global-head-short'
		}, {
			title: '社保基数',
			dataIndex: 'social_insurance_base',
			key: 'social_insurance_base',
			className: 'table-global-head-short'
		}, {
			title: '公积金基数',
			dataIndex: 'provident_fund_base',
			key: 'provident_fund_base',
			className: 'table-global-head-short'
		}, {
			title: '险种',
			dataIndex: 'insurance_type_str',
			key: 'insurance_type_str',
			className: 'table-global-head-short'
		}, {
			title: '个人养老保险费率',
			dataIndex: 'pension_rates_personal',
			key: 'pension_rates_personal',
			className: 'table-global-head'
		}, {
			title: '个人医疗费率',
			dataIndex: 'medical_rates_personal',
			key: 'medical_rates_personal',
			className: 'table-global-head-6x'
		}, {
			title: '个人失业费率',
			dataIndex: 'unemployment_rates_personal',
			key: 'unemployment_rates_personal',
			className: 'table-global-head-6x'
		}, {
			title: '个人公积金费率',
			dataIndex: 'provident_fund_rates_personal',
			key: 'provident_fund_rates_personal',
			className: 'table-global-head-65x'
		}, {
			title: '单位养老费率',
			dataIndex: 'pension_rates_unit',
			key: 'pension_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位医疗费率',
			dataIndex: 'medical_rates_unit',
			key: 'medical_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位失业费率',
			dataIndex: 'unemployment_rates_unit',
			key: 'unemployment_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位工伤费率',
			dataIndex: 'work_injury_rates_unit',
			key: 'work_injury_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位生育费率',
			dataIndex: 'fertility_rates_unit',
			key: 'fertility_rates_unit',
			className: 'table-global-head-6x'
		}, {
			title: '单位公积金费率',
			dataIndex: 'provident_fund_rates_unit',
			key: 'provident_fund_rates_unit',
			className: 'table-global-head-65x'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head-small',
			render: (text, record, index) => (
				<DynamicButton column={this.buttonColumn(text, record, index)}
					module={this.childModuleName}
					access={this.props.access} />
			)
		}
	]

	buttonColumn = (text, record, index) => [{
			size: "small",
			type: "default",
			icon: "edit",
			title: "编辑",
			access: "u_value",
			click: this.updateData.bind(this, record, index)
		}
	]

	formColumn = () => [{
			label: "地区",
			key: "area",
			type: "text"
		}, {
			label: "险种",
			key: "insurance_type_str",
			type: "text"
		}, {
			label: "基数",
			type: "title",
		}, {
			label: "个税基数",
			key: "personal_tax_base",
			type: "number",
			rules: {min: 0, step: 0.01}
		}, {
			label: "社保基数",
			key: "social_insurance_base",
			type: "number",
			rules: {min: 0, step: 0.01}
		}, {
			label: "公积金基数",
			key: "provident_fund_base",
			type: "number",
			rules: {min: 0, step: 0.01}
		}, {
			label: "个人",
			type: "title",
		}, {
			label: "养老费率",
			key: "pension_rates_personal",
			type: "number",
			rules: {min: 0, step: 0.1, max: 100}
		}, {
			label: "医疗费率",
			key: "medical_rates_personal",
			type: "number",
			rules: {min: 0, step: 0.1, max: 100}
		}, {
			label: "失业费率",
			key: "unemployment_rates_personal",
			type: "number",
			rules: {min: 0, step: 0.1, max: 100}
		}, {
			label: "公积金费率",
			key: "provident_fund_rates_personal",
			type: "number",
			rules: {min: 0, step: 0.1, max: 100}
		}, {
			label: "单位",
			type: "title",
		}, {
			label: "养老费率",
			key: "pension_rates_unit",
			type: "number",
			rules: {min: 0, step: 0.1, max: 100}
		}, {
			label: "医疗费率",
			key: "medical_rates_unit",
			type: "number",
			rules: {min: 0, step: 0.1, max: 100}
		}, {
			label: "失业费率",
			key: "unemployment_rates_unit",
			type: "number",
			rules: {min: 0, step: 0.1, max: 100}
		}, {
			label: "公积金费率",
			key: "provident_fund_rates_unit",
			type: "number",
			rules: {min: 0, step: 0.1, max: 100}
		}, {
			label: "工伤费率",
			key: "work_injury_rates_unit",
			type: "number",
			rules: {min: 0, step: 0.1, max: 100}
		}, {
			label: "生育费率",
			key: "fertility_rates_unit",
			type: "number",
			rules: {min: 0, step: 0.1, max: 100}
		},
	]

	updateData = (record, index) => this.setState({
		currentData: this.dataSource().data.Data[index],
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: index
	})

	render () {
		return (
			<div className="app-module-item">
				<div className="app-module-header">
				</div>
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="参保设置"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.publicSubmit} >
					<DynamicForm column={this.formColumn}
						form={this.props.form}
						loadStatus={this.state.currentDataStatus}
						dataSource={this.state.currentData} />
				</Modal>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page}}
						rowSelection={this.rowSelection}
						setPageFilter={this.actions.changeAction} />
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		salaryAllowance: state.salaryAllowance,
	}
}

const mapDispatchToProps = {
	changeInsuranceManagement,
	selectInsuranceManagement,
	updateInsuranceManagement,
}

InsuranceManagement = Form.create()(InsuranceManagement);

InsuranceManagement = connect(mapStateToProps, mapDispatchToProps)(InsuranceManagement);

export default LayoutWrapper(InsuranceManagement);





// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/InsuranceManagement.js